import React, { Component } from 'react'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import request from '../../lib/requester'
import _ from 'lodash'
import ReactExport from "react-export-excel"
import moment from 'moment'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn


class userlist extends Component {


    constructor(props) {
        super(props);
        
        this.state = {
            dataTable: [],
            baseTable: [],
            search: '',
            user: JSON.parse(window.localStorage.getItem('is_user'))
        }
    }
    
    componentDidMount = () => {
        let url = '/api/infostep/v1/user/userlist'
        let param = {
            org_id: this.state.user.org_id
        }
        this.setState({ loading: true })
        request.postInfostep(url, param, {
            success: function(response) {
                let { data } = response.data
                data.map((item, index) => {
                    item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
                    item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
                    return item
                })
                this.setState({ loading: false, dataTable: data, baseTable: data})
            }.bind(this),
            error: function(e) {
                this.setState({ loading: false })
            }.bind(this)
        })
    }

    renderTable = () => {
        const data = {
          columns: [
            {
              Header: "User Name",
              accessor: "username",
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 200,
            },
            {
              Header: "Real Name",
              accessor: "realname",
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 200,
            },
            {
              Header: "Phone",
              accessor: "phone",
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              //   width: 250,
            },
            {
              Header: "Principal",
              accessor: "princ",
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              //   width: 250,
            },
            {
              Header: "Role",
              accessor: "role",
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              //   width: 250,
            },
            {
              Header: "Active",
              accessor: "active_flag",
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              //   width: 250,
            },
            // {
            //     Header: 'CREATION DATE',
            //     accessor: 'creation_date',
            // 	Cell: row => (
            // 		<span>
            // 			<span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY") : ""}
            // 			</span>
            // 		</span>
            // 	)
            // },
            // {
            //     Header: 'CREATED BY',
            //     accessor: 'username',

            // },
            {
              Header: "",
              accessor: "user_id",
              width: 90,
              Cell: (row) => (
                <span>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => {
                      this.goDetail(row);
                    }}
                  >
                    Update <i className="fas fa-check" />
                  </button>
                </span>
              ),
            },
          ],
          rows: this.state.dataTable,
        };
        return (
          <ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
            defaultFilterMethod={(filter, row, column) => {
              let columnes = row[filter.id];
              return columnes
                ? columnes.toLowerCase().includes(filter.value.toLowerCase())
                : "";
            }}
          />
        );
    }

    handleSearch = (e) => {
    let value = e.target.value
    this.setState({ search: value })
    let baseTable = _.filter(this.state.baseTable, function(o) {
        return o.username.toLowerCase().includes(value.toLowerCase())
    })
    this.setState({ dataTable: baseTable })
    }

    goDetail = (rows) => {
        let { row } = rows
        this.props.history.push('/admin/setup/user/userupdate/' + row.user_id)
    }


    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row ml-1">
                            <div className="col-lg-12">
                                <div className="card card-info">
                                    <div className="card-header">List</div>
                                    <div className="card-body">
                                        {/* <div className="row">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control" placeholder="Search User..." onChange={ this.handleSearch.bind(this) } />
                                            </div>
                                        </div> */}
                                        <div className="clearfix">&nbsp;</div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                { this.renderTable() }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }



}
export default userlist